import React from "react";
import { Header, flexRender } from "@tanstack/react-table";
import clsx from "clsx";

export interface TDataGridTableHeadCellProps<TData, TValue> {
  header: Header<TData, TValue>;
}

// Option 1: Remove unused generic parameters completely
export interface CustomColumnMeta {
  className?: string;
  cellClassName?: string;
}

// Option 2: If you need the generics for future use, disable ESLint for this interface

// export interface CustomColumnMeta<TData, TValue> {
//     className?: string;
//     cellClassName?: string;
// }

const DataGridTableHeadCell = <TData, TValue>({
  header,
}: TDataGridTableHeadCellProps<TData, TValue>) => {
  return (
    <th
      key={header.id}
      colSpan={header.colSpan}
      className={clsx(
        (header.column.columnDef.meta as CustomColumnMeta)?.className, // Updated type reference
      )}
    >
      {header.column.columnDef.enableSorting ? (
        <div
          className={clsx(
            header.column.getCanSort() ? "cursor-pointer select-none" : "",
          )}
          onClick={header.column.getToggleSortingHandler()}
        >
          <span
            className={clsx("sort", {
              [`${header.column.getIsSorted()}`]: header.column.getIsSorted(),
            })}
          >
            <span className="sort-label">
              {flexRender(header.column.columnDef.header, header.getContext())}
            </span>
            <span className="sort-icon"></span>
          </span>
        </div>
      ) : (
        <span>
          {flexRender(header.column.columnDef.header, header.getContext())}
        </span>
      )}
    </th>
  );
};

export { DataGridTableHeadCell };
